// tslint:disable-next-line:no-submodule-imports
import 'react-tabs/style/react-tabs.css';

import * as ClientModule from '../../redux/modules/client';

import { RootState } from '../../redux/modules';
import AdditionalContacts, {
  AdditionalContatctsProps,
} from '../../components/UI/additional-contact/additioal-contact-form';

import Button from '../../ui_components/button/button';
import Checkbox from '../../ui_components/checkbox/checkbox';
import { FormValidationError } from '../../ui_components/validation/validationForm';
import { PopoverScrollContext } from '../../ui_components/popover/popover';
import TextArea from '../../ui_components/textArea/textArea';
import ValidationForm from '../../ui_components/validation/validationForm';
import { ValidationPopupInput } from '../../ui_components/validation/validationPopupInput';
import { Modal, ModalActions, ModalContent, ModalHeader } from '../../ui_components/modal';
import PageDimmer from '../../ui_components/dimmer/PageDimmer';
import { DispatchProp, connect } from 'react-redux';
import MainInfo, { MainInfoProps } from './client-main-info';
import React, { ChangeEvent, FormEvent, KeyboardEvent, PureComponent, UIEvent } from 'react';
import { Tab, TabList, TabPanel, Tabs } from 'react-tabs';
import styled, { theme } from '../../theme';
import { AvatarModal } from '../../modals/avatar_modal';
import BillingInfo from './client-billing-info';
import Bind from 'lodash-decorators/bind';
import { ValidationError } from '@quipa/api';
import { detect } from 'detect-browser';
import { formatPhoneNumber } from '../../utils/phone';
import { ClientAddressDetails } from '@quipa/api/build-ts/client';
import { addClient, editClient, getClientApi, searchClients } from '../../api/client';
import { Config } from '../../utils';
import { uploadImage } from '../../api/account';
import { trackView } from '../../components/analytics/track_view';
import { MixpanelEvents } from '../../components/analytics/mix_panel_events';
import { addProject } from '../../api/projects';
import { Omit } from '../..';
import { extractParent } from '../../helper/helpers';

const noop = () => {
  return;
};

const EMAIL_PATTERN = /^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/;

const validateEmailList = (
  rawValue: string
): { isValid: boolean; invalidEmail?: string; hasEmpty?: boolean } => {
  const trimmedValue = rawValue.trim();
  if (!trimmedValue) {
    return { isValid: true };
  }

  const emails = rawValue.split(',').map((email) => email.trim());

  for (const email of emails) {
    if (email.length === 0) {
      return { isValid: false, hasEmpty: true };
    }
    if (!EMAIL_PATTERN.test(email)) {
      return { isValid: false, invalidEmail: email, hasEmpty: false };
    }
  }

  return { isValid: true };
};

const getEmailValidationMessage = (value: string): string | undefined => {
  const { isValid, invalidEmail, hasEmpty } = validateEmailList(value);
  if (isValid) {
    return undefined;
  }
  if (hasEmpty) {
    return 'Remove extra commas; every email entry must contain a valid address.';
  }
  if (invalidEmail) {
    return `"${invalidEmail}" is not a valid email address.`;
  }
  return 'Enter valid email addresses separated by commas.';
};

const AdditionalContactsMessage = styled.div`
  font-size: 16px !important;
  color: red !important;
  text-align: center !important;
`;

export const TwoItemsWrapper = styled.div`
  display: flex !important;
  justify-content: space-between !important;
  margin-bottom: 8px !important;
  > div {
    width: 48% !important;
  }
`;

export const ThreeItemsWrapper = styled(TwoItemsWrapper)`
  > div:nth-child(1) {
    width: 48% !important;
  }

  > div:nth-child(2) {
    width: 17% !important;
    min-width: 80px !important;
  }

  > div:nth-child(3) {
    width: 27% !important;
  }
`;

// this shit is losing the original classname when using styled()
const TabContainer = styled(TabPanel).attrs({
  className: 'react-tabs__tab-panel',
})`
  height: 518px !important;
  overflow: auto !important;
  flex: 1 auto !important;
`;

export const LeftCell = styled.div`
  width: 50% !important;
  margin-bottom: 20px !important;
  padding-right: 1.25rem !important;
`;

export const RightCell = styled(LeftCell)`
  padding-right: 0 !important;
  padding-left: 1.25rem !important;
`;

export const RightCellWithBorder = styled(RightCell)`
  border-left: 1px solid #338daa !important;
`;

export const ClientBlock = styled.div`
  display: flex !important;
  width: 100% !important;
  flex-wrap: wrap !important;
  align-items: flex-start !important;
  // height: 100% !important;
  min-height: inherit !important;
  // flex: 1 !important;

  > div {
    margin-bottom: 11px !important;
    margin-top: 20px;
  }

  .label {
    width: 100% !important;
    border-radius: 0.5em !important;
  }

  .text-area {
    width: 600px !important;
    height: 200px !important;
    margin-top: 15px !important;
    border: 1px solid #d2d8dd !important;
    border-radius: 0 !important;
    box-shadow: 4px 4px 4px 1px #c1c2c3 !important;
    padding: 2.5em 1.5em !important;

    &::placeholder {
      color: #338daa !important;
    }
  }
`;

export const ClientFormInput = styled(ValidationPopupInput as any)`
  padding: 0.35em 0.5em !important;
`;

export const ValidationRadioInput = styled(ClientFormInput)`
  border-radius: 50% !important;
  width: 15px !important;
  height: 15px !important;
  font-size: 0 !important;
  margin-right: 5px !important;
  border: 1px solid ${theme.colors.grayRGBA} !important;
  border: ${(props) => (props.checked ? '5px solid #338daa' : '')} !important;

  input {
    visibility: hidden !important;
  }
`;

export const SalesTaxInput = styled(ClientFormInput)`
  flex: 1 !important;
`;

export const ClientFormSubtitle = styled.h4`
  color: #338daa;
  font-weight: bold;
  letter-spacing: 1.5px;
  display: flex;
  align-items: center;
  place-content: space-between;
`;

export const ClientFormFooter = styled.div`
  border-top: 1px solid #bebebe !important;
  display: flex !important;
  width: 100% !important;
  margin-bottom: 0 !important;
  margin-top: 1em !important;
  padding: 1.25em 0 !important;

  > div {
    width: 50% !important;
  }

  > div:last-child {
    justify-content: flex-start !important;
    padding-left: 1.25rem !important;
  }

  .project-manager-wrapper {
    display: flex !important;
    align-items: center !important;
    justify-content: flex-end !important;

    > label:first-child {
      margin-right: 15px !important;
      width: auto !important;
    }

    > label {
      width: 55% !important;
    }
  }
`;

export const ClientFormLabel = styled.label`
  color: ${theme.colors.grayRGBA} !important;

  .red-asterisk {
    color: #ff6084 !important;
  }
`;

const FormErrors = styled.div`
  color: #82848b !important;
  overflow: hidden !important;
  background-color: #f8d7da !important;
  border-color: #f5c6cb !important;
  margin-bottom: 5px !important;
`;

const FormError = styled.div`
  margin: 5px !important;
`;

export const CancelButton = styled(Button)`
  margin-right: auto !important;
  box-shadow: none !important;
`;

export const SaveButton = styled(Button)`
  box-shadow: none !important;
`;

export const AddButton = styled(SaveButton)`
  width: 115px !important;
  margin: auto auto 0 auto !important;
`;

const ModalContainer = styled(Modal)`
  width: 90% !important;
  min-height: 300px !important;
  bottom: 0 !important;
`;

const ModalForm = styled(ValidationForm)`
  height: 100% !important;
  min-height: inherit !important;
`;

const ModalHeaderClient = styled(ModalHeader)`
  color: #306f82 !important;
  border-bottom: none !important;
  padding-bottom: 0 !important;

  div {
    width: 100% !important;
    border-bottom: 10px solid #e6f1f4 !important;
    display: flex !important;
    justify-content: space-between !important;
    align-items: center !important;
    padding-bottom: 0.5rem !important;
  }

  .modal-title {
    font-size: 26px !important;
  }
`;

const ModalContentClient = styled(ModalContent)`
  display: flex !important;
  flex-direction: column !important;
  height: 100% !important;
  min-height: inherit !important;

  .react-tabs__tab-list {
    border-bottom: 6px solid #338daa !important;
    margin-bottom: 0 !important;
  }

  .react-tabs__tab {
    margin-right: 10px !important;
    border-radius: 5px 5px 0 0 !important;
    border: 1px solid #aaa !important;
    border-bottom: none !important;
    bottom: 0 !important;
    background-color: white !important;
    color: ${theme.colors.grayRGBA} !important;

    &:last-child {
      margin-right: 0 !important;
    }
  }

  .react-tabs__tab-panel {
    flex: 1 !important;
  }

  .react-tabs__tab--selected {
    background-color: #338daa !important;
    color: #fff !important;
    border-color: transparent !important;

    &:focus {
      outline: none !important;
    }
  }

  .react-tabs__tab-panel--selected {
    margin-top: 0 !important;
    display: flex !important;
    flex-direction: column !important;
  }

  .react-tabs__tab:focus {
    box-shadow: none !important;
  }

  .react-tabs__tab:focus::after {
    position: relative !important;
  }
`;

export const ModalTabs = styled(Tabs)`
  flex: 1 !important;
  display: flex !important;
  flex-direction: column !important;
  height: 100% !important;
  min-height: inherit !important;
`;

export const ClientCheckbox = styled(Checkbox)`
  color: ${theme.colors.grayRGBA} !important;
  font-size: 0.85em !important;
`;

export const DisableAutocompleteInput = styled.input`
  display: none !important;
`;

const NameSeperator = styled.span`
  font-size: 24px !important;
  font-weight: 400 !important;
  color: #9e999f !important;
  padding: 0 10px !important;
`;

const ParentName = styled.a`
  color: #9e999f !important;
  font-size: 20px !important;
`;

const Name = styled.a`
  color: #51a6c5 !important;
  font-size: 20px !important;
  flex: 1 !important;
`;

const defaultBillingFieldValues = (): ClientModule.ClientAddressDetails => ({
  firstName: '',
  lastName: '',
  streetAddress: '',
  unitSuite: '',
  cityTown: '',
  country: '',
  stateProvince: '',
  zipCode: '',
  cellPhone: '',
  homePhone: '',
  fax: '',
  company: '',
  officePhone: '',
  email: '',
  website: '',
  billingType: '',
  additionalPriceAdjustment: 'none',
  additionalPriceAdjustmentValue: '',
});

const normalizeBillingFieldValues = (
  billingDetails?: any,
  fallbackCompany?: any
): ClientModule.ClientAddressDetails => {
  const source = billingDetails || {};
  return {
    ...defaultBillingFieldValues(),
    ...source,
    stateProvince: source.stateProvince || source.province || '',
    company: source.company || source.companyName || fallbackCompany || '',
    additionalPriceAdjustment: source.additionalPriceAdjustment || 'none',
    additionalPriceAdjustmentValue: source.additionalPriceAdjustmentValue || '',
  };
};

const defaultFieldValues = (): ClientFields => ({
  active: true,
  id: 0,
  avatarId: '',
  firstName: '',
  lastName: '',
  displayName: '',
  email: '',
  streetAddress: '',
  unitSuite: '',
  cityTown: '',
  country: '',
  stateProvince: '',
  zipCode: '',
  cellPhone: '',
  homePhone: '',
  fax: '',
  company: '',
  officePhone: '',
  website: '',
  projectManager: '',
  parentClientId: 0,
  notes: '',
  billingSalesTax: '',
  billingType: '',
  billToParent: false,
  billingDetails: defaultBillingFieldValues(),
  billingDetailsDirectly: defaultBillingFieldValues(),
  additionalContactDetails: [],
  customDisplayName: false,
});

interface ClientModalOwnProps {
  onUpdateModalKey?(): void;
  isModalOpen: boolean;
  client?: ClientModule.Client;
  resetOnClose: boolean;
  onModalClose(): void;
  onClientSaved(client: ClientModule.Client): void;
  setFocusFirstField(fn: any): void;
  getRooms?(id: number): void;
  getClient?(): Promise<void>;

  highlightedSection?: string | null | undefined;
  tabIndex?: number;
  updateStateByName?: (
    name: string,
    value: string | number | boolean | object | number[] | undefined,
    isSaving?: boolean | undefined
  ) => void;
  clearHighlightSection?(name: string): void;
  addSubClient?: boolean;
  parentClients?: any[];
}

export interface ClientModalProps extends ClientModalOwnProps {
  accountId: number;
}

export interface ClientFields extends Omit<ClientModule.Client, 'subClients' | 'subClientsIds'> {}

interface State {
  showSubClientMenuList: boolean;
  formFields: ClientFields;
  /**
   * Only used for displaying
   */
  isOpen: boolean;
  parentClientName: string;
  parentClientId: number | null;
  formErrors: string[];
  imageModalOpen: boolean;
  isCustomDisplayName: boolean;
  tabIndex: number;
  areaScrollInfo: {
    scrollX: number;
    scrollY: number;
  };
  stateList: string[];
  additionalFormOpen: boolean;
  clientBillingDetails: ClientAddressDetails;
  canChange: boolean | string | undefined;
  billingType: string | undefined;
  isParentChanged: boolean;
  parentClients: number;
  addClientError: {
    error: boolean;
    message: string;
  };
  emailValidationErrors: Record<string, string>;
}

// asvetl:
// 1. Consider moving each section to own component, especially additional contact info form since it's isolated
// 2. Validation, need to have better story for validation, most errors for fields are displayed through popup, but few ones are through message block
// Thoughts:
//
// 2.1 If you want to have validation popups for all, there is a problem: hidden tabs aren't being rendered by dom (and thus aren't being validated). But it can fixed through <Tabs forceRenderTab> or so
// But if you enable it, the popup may appear for non-active tab and thus won't be visible
// To fix the UX, you need:
// 2.1.1 make Tabs as controlled component (with index/onSelect with index being the state variable) to switch tab to the correct validation
// 2.1.2 use uiOnInvalidElem/uiOnInvalidForm to obtain failed html element, then get it's index (you can put id="page" data-index={1} on page, then use elem.closest("#page").dataset to get the page index) and switch page to failed element
//
// 2.2 You can display all errors in the message list, like:
// - A is required
// - B should be URL
// 2.2.1 For this use ValidationInput instead ValidationPopupInput and pass uiOnValid/uiOnInvalid, then you can store/delete error from the state
export class ClientModal extends PureComponent<ClientModalProps & DispatchProp, State> {
  private firstFieldRef = React.createRef<HTMLInputElement>();

  public constructor(props: ClientModalProps & DispatchProp) {
    super(props);
    const { client } = props;
    const stateList: string[] = [
      'AL',
      'AK',
      'AZ',
      'AR',
      'CA',
      'CO',
      'CT',
      'DE',
      'DC',
      'DR',
      'FL',
      'GA',
      'HI',
      'ID',
      'IL',
      'IN',
      'IA',
      'KS',
      'KY',
      'LA',
      'ME',
      'MT',
      'NE',
      'NV',
      'NH',
      'NJ',
      'NM',
      'NY',
      'NC',
      'ND',
      'OH',
      'OK',
      'OR',
      'MD',
      'MA',
      'MI',
      'MN',
      'MS',
      'MO',
      'PA',
      'RI',
      'SC',
      'SD',
      'TN',
      'TX',
      'UT',
      'VT',
      'VA',
      'WA',
      'WV',
      'WI',
      'WY',
    ];
    let sortedStateList = [...stateList];
    sortedStateList.sort((a: string, b: string) => (a > b ? 1 : -1));
    this.state = {
      areaScrollInfo: {
        scrollX: 0,
        scrollY: 0,
      },
      isParentChanged: false,
      isOpen: false,
      showSubClientMenuList: !!(client && client.parentClientId),
      imageModalOpen: false,
      isCustomDisplayName: !!client,
      tabIndex: this.props.tabIndex ? this.props.tabIndex : 0,
      formErrors: [],
      formFields: client
        ? {
            ...client,
            billToParent: client.billToParent,
            billingDetails: normalizeBillingFieldValues(client.billingDetails, client.company),
            additionalContactDetails: this.props.addSubClient
              ? []
              : [...client.additionalContactDetails],
          }
        : defaultFieldValues(),
      parentClientName: client && client.parent ? client.parent.displayName : '',
      parentClientId: client && client.parent ? client.parent.id : 0,
      clientBillingDetails: client ? client.billingDetails : defaultFieldValues(),
      stateList: sortedStateList,
      additionalFormOpen: false,
      canChange: client ? client.customDisplayName : false,
      billingType:
        client && client.billToParent
          ? client.billingDetails.billingType
          : client && client.billingDetailsDirectly
            ? client.billingDetailsDirectly.billingType
            : undefined,
      parentClients: 0,
      addClientError: {
        error: false,
        message: '',
      },
      emailValidationErrors: {},
    };
  }

  public componentDidMount() {
    if (this.props.isModalOpen) {
      trackView(MixpanelEvents.CLIENT_DETAILS_PROFILE, {});
      if (this.state.tabIndex === 0) {
        trackView(MixpanelEvents.CLIENT_PROFILE_INFO, {});
      }
    }

    if (this.props.client) {
      this.setState({
        clientBillingDetails: this.props.client.billingDetails,
      });
    }
    this.props.setFocusFirstField(this.setFocusOnFirstField);
  }
  componentDidUpdate(prevProps: any, prevState: any) {
    if (prevProps.isModalOpen !== this.props.isModalOpen && this.props.isModalOpen) {
      trackView(MixpanelEvents.CLIENT_DETAILS_PROFILE, {});
      if (this.state.tabIndex === 0) {
        trackView(MixpanelEvents.CLIENT_PROFILE_INFO, {});
      }
    }

    if (prevState.tabIndex !== this.state.tabIndex) {
      const index_view_relation: any = {
        '0': MixpanelEvents.CLIENT_PROFILE_INFO,
        '1': MixpanelEvents.CLIENT_PROFILE_BILLING,
        '2': MixpanelEvents.CLIENT_PROFILE_NOTES,
        '3': MixpanelEvents.CLIENT_PROFILE_CONTACTS,
      };
      trackView(index_view_relation[this.state.tabIndex], {});
    }

    if (prevProps.client !== this.props.client) {
      const { client, addSubClient } = this.props;

      const formFieldsPayload = client
        ? {
            ...client,
            billToParent: client.billToParent,
            billingDetails: normalizeBillingFieldValues(client.billingDetails, client.company),
            billingDetailsDirectly: normalizeBillingFieldValues(
              client.billingDetailsDirectly,
              client.company
            ),
            additionalContactDetails: this.props.addSubClient
              ? []
              : [...client.additionalContactDetails],
          }
        : defaultFieldValues();

      this.setState((prev) => {
        return {
          parentClientName: client && client.parent ? client.parent.displayName : '',
          parentClientId: client && client.parent ? client.parent.id : 0,
          formErrors: [],
          showSubClientMenuList: client && client.parent ? true : false,
          isCustomDisplayName: false,
          tabIndex: this.props.tabIndex ? this.props.tabIndex : 0,
          canChange: client ? client.customDisplayName : false,
          formFields: addSubClient ? prev.formFields : formFieldsPayload,
        };
      });

      setTimeout(() => {
        const bill_to_case = addSubClient ? '1' : formFieldsPayload.billToParent ? '1' : '0';

        const state_payload = {
          ...this.state.formFields,
          billToParent: true,
        };

        const form_payload = addSubClient ? state_payload : formFieldsPayload;
        // For "This Client Directly", keep persisted billingDetailsDirectly as-is.
        // Re-running the billing initializer for case "0" can overwrite billing data
        // with Client Info fields when the modal is reopened.
        if (bill_to_case === '1') {
          this.handleInitialBillingInfoWrapper(bill_to_case, form_payload);
        }
      }, 1000);
      // Update state or perform other actions if needed
    }
    if (prevProps.addSubClient !== this.props.addSubClient) {
      const { addSubClient, client } = this.props;
      if (addSubClient) {
        this.setState((prev) => {
          return {
            ...prev,
            formFields: {
              active: true,
              id: addSubClient && client ? client.id : 0,
              avatarId: '',
              firstName: '',
              lastName: '',
              displayName: '',
              email: '',
              streetAddress: '',
              unitSuite: '',
              cityTown: '',
              country: '',
              stateProvince: '',
              zipCode: '',
              cellPhone: '',
              homePhone: '',
              fax: '',
              company: '',
              officePhone: '',
              website: '',
              projectManager: '',
              parentClientId: addSubClient && client ? client.id : 0,
              notes: '',
              billingSalesTax: '',
              billingType: '',
              billToParent: true,
              billingDetailsDirectly: defaultBillingFieldValues(),
              customDisplayName: false,
              billingDetails: client
                ? !client.billToParent
                  ? normalizeBillingFieldValues(client.billingDetailsDirectly, client.company)
                  : normalizeBillingFieldValues(client.billingDetails, client.company)
                : defaultBillingFieldValues(),
              additionalContactDetails: this.props.addSubClient
                ? []
                : client
                  ? [...client.additionalContactDetails]
                  : [],
            },
          };
        });
      }
      this.setState({
        showSubClientMenuList: addSubClient ? true : client && client.parent ? true : false,
        parentClientName:
          addSubClient && client
            ? client.displayName
            : client && client.parent
              ? client.parent.displayName
              : '',
        parentClientId:
          addSubClient && client ? client.id : client && client.parent ? client.parent.id : 0,
        isCustomDisplayName: false,
      });
    }
  }

  public setFocusOnFirstField = () => {
    if (this.firstFieldRef.current) {
      this.firstFieldRef.current.focus();
    }
  };

  public render(): JSX.Element {
    // const hasEmailErrors = Object.keys(this.state.emailValidationErrors).length > 0;
    const billingReleaseDate = new Date('2026-01-23');
    const thirtyDaysAfterBillingRelease = new Date(billingReleaseDate);
    thirtyDaysAfterBillingRelease.setDate(thirtyDaysAfterBillingRelease.getDate() + 30);
    const showBillingInfoBadge = thirtyDaysAfterBillingRelease > new Date();
    return (
      <>
        <PageDimmer uiActive={this.props.isModalOpen} />
        <AvatarModal
          uiActive={this.state.imageModalOpen}
          uiOnRequestClose={this.closeAvatarModal}
          onSave={this.saveAvatarImage}
        />
        <ModalContainer
          uiActive={this.props.isModalOpen}
          uiOnRequestClose={noop}
          uiDefaultSizes={false}
        >
          <ModalForm
            uiOnSubmit={this.handleSubmitForm}
            uiOnInvalidElem={this.handleInvalidElem}
            uiReportValidityMode="firstInvalid"
            onKeyPress={this.handleKeyPressForm}
            uiPadding={false}
          >
            <DisableAutocompleteInput name="firstName" />
            <ModalHeaderClient>
              <div>
                <span className="modal-title">Client Profile</span>
                {(this.state.showSubClientMenuList || this.state.formFields.displayName) && (
                  <NameSeperator> - </NameSeperator>
                )}
                {this.state.showSubClientMenuList && (
                  <>
                    <ParentName>{`${this.state.parentClientName}`}</ParentName>
                    <NameSeperator> | </NameSeperator>
                  </>
                )}
                <Name>{`${this.state.formFields.displayName || ''}`}</Name>
                <ClientCheckbox
                  checked={!this.state.formFields.active}
                  onClick={this.handleChangeInactiveClient}
                >
                  Make Inactive
                </ClientCheckbox>
              </div>
            </ModalHeaderClient>

            <ModalContentClient>
              <FormErrors>
                {this.state.formErrors.map((error) => (
                  <FormError key={error}>{error}</FormError>
                ))}
              </FormErrors>

              <PopoverScrollContext.Provider value={this.state.areaScrollInfo}>
                <ModalTabs
                  selectedIndex={this.state.tabIndex}
                  onSelect={this.selectTab}
                  forceRenderTabPanel
                >
                  <TabList>
                    <Tab>
                      {this.state.formFields.parentClientId ? 'Sub-Client Info' : 'Client Info'}
                    </Tab>
                    <Tab>
                      <span
                        style={{
                          display: 'inline-flex',
                          alignItems: 'center',
                          gap: '8px',
                        }}
                      >
                        Billing Info
                        {showBillingInfoBadge ? <span className={'new_pill'}>New</span> : null}
                      </span>
                    </Tab>
                    <Tab>Notes</Tab>
                    <Tab>Additional Contacts</Tab>
                  </TabList>
                  {this.renderMainInfo()}

                  {this.renderBillingInfo()}

                  {this.renderNotes()}

                  {this.renderAdditionalContactInfo()}
                  <AdditionalContactsMessage>
                    {this.state.isOpen ? 'Please save or close "Additional Contacts" form' : ''}
                  </AdditionalContactsMessage>
                </ModalTabs>
              </PopoverScrollContext.Provider>
            </ModalContentClient>

            <ModalActions>
              <CancelButton
                className="cancel_btn"
                type="button"
                uiColor="secondary"
                onClick={() => this.handleClose('cancel')}
              >
                Cancel
              </CancelButton>

              <SaveButton
                uiColor="primary"
                disabled={this.state.additionalFormOpen}
                uiDisabled={this.state.additionalFormOpen}
              >
                Save
              </SaveButton>
            </ModalActions>
          </ModalForm>
        </ModalContainer>
      </>
    );
  }

  public renderMainInfo(): JSX.Element {
    return (
      <TabContainer onScroll={this.onTabAreaScoll}>
        <MainInfo
          formFields={this.state.formFields}
          stateList={this.state.stateList}
          showSubClientMenuList={this.state.showSubClientMenuList}
          openAvatarModal={this.openAvatarModal}
          deleteAvatarImage={this.deleteAvatarImage}
          handleFieldChange={this.handleFieldChange}
          handleChangeDisplayName={this.handleChangeDisplayName}
          handleToggleSubClientMenuList={this.handleToggleSubClientMenuList}
          handleFieldState={this.handleFieldState}
          handleSelectClient={this.handleSelectClient}
          handleSearch={this.handleSearch}
          handleClearKeyword={this.handleClearKeyword}
          initialParentClientName={this.state.parentClientName}
          ref={this.firstFieldRef}
          addClientError={this.state.addClientError}
          handleAddClientError={this.handleAddClientError}
          emailErrors={this.state.emailValidationErrors}
        />
      </TabContainer>
    );
  }

  public renderBillingInfo(): JSX.Element {
    return (
      <TabContainer onScroll={this.onTabAreaScoll}>
        <BillingInfo
          formFields={
            this.state.formFields.billToParent
              ? this.state.formFields
              : {
                  ...this.state.formFields,
                  billingDetails: this.state.formFields.billingDetailsDirectly || {},
                }
          }
          stateList={this.state.stateList}
          taxList={['Item 1', 'Item 2', 'Item 3']}
          billingTypeList={['Retail', 'Trade']}
          showSubClientMenuList={this.state.showSubClientMenuList}
          handleFieldChange={this.handleFieldChange}
          handleFieldState={this.handleFieldState}
          handleFieldFromSelect={this.handleFieldFromSelect}
          // handleInitialBillingInfoWrapper={this.handleInitialBillingInfoWrapper}
          highlightedSection={this.props.highlightedSection}
          emailErrors={this.state.emailValidationErrors}
          handleAdditionalPriceAdjustment={this.handleAdditionalPriceAdjustment}
          handleAdditionalPriceAdjustmentValue={this.handleAdditionalPriceAdjustmentValue}
          handleAdditionalPriceAdjustmentValueBlur={this.handleAdditionalPriceAdjustmentValueBlur}
        />
      </TabContainer>
    );
  }

  public renderAdditionalContactInfo(): JSX.Element {
    return (
      <TabContainer onScroll={this.onTabAreaScoll}>
        <AdditionalContacts
          contacts={this.state.formFields.additionalContactDetails}
          stateList={this.state.stateList}
          additionalFormOpen={this.state.additionalFormOpen}
          onAdditionalContactsChanged={this.changeAdditionalContacts}
          deleteContact={this.deleteAdditionalContact}
          isOfClient
          setAdditionalFormStatus={this.setAdditionalFormStatus}
          isOpen={this.state.isOpen}
          updateParentState={this.updateParentState}
        />
      </TabContainer>
    );
  }

  public renderNotes(): JSX.Element {
    const browser = detect();
    return (
      <TabContainer onScroll={this.onTabAreaScoll}>
        <ClientBlock>
          <div>
            <TextArea
              name="notes"
              placeholder="NOTES"
              onChange={this.handleFieldChange}
              value={this.state.formFields.notes}
              autoComplete={browser && browser.name === 'chrome' ? 'new-password' : 'off'}
            />
          </div>
        </ClientBlock>
      </TabContainer>
    );
  }

  updateParentState = () => {
    this.setState({ isOpen: false });
  };

  public selectTab = (index: number) => {
    const { formFields } = this.state;

    let billingDetailsUpdate = { ...formFields.billingDetails };

    if (
      index === 1 &&
      !formFields.billToParent &&
      !this.isCustomBillingInfo(formFields.billingDetails)
    ) {
      billingDetailsUpdate = this.preFillFields(billingDetailsUpdate); // NOSONAR
    }
    this.setState({
      tabIndex: index,
      areaScrollInfo: {
        scrollX: 0,
        scrollY: 0,
      },
      formFields: {
        ...formFields,
        billingDetails: { ...formFields.billingDetails },
      },
    });
  };

  public onTabAreaScoll = (e: UIEvent<HTMLDivElement>) => {
    const { scrollTop } = e.currentTarget;
    this.setState({
      areaScrollInfo: {
        scrollX: 0,
        scrollY: scrollTop,
      },
    });
  };

  public handleInvalidElem = (e: HTMLElement): void => {
    if (e.dataset.index && +e.dataset.index !== this.state.tabIndex) {
      this.setState({ tabIndex: +e.dataset.index }, () => {
        e.scrollIntoView({ behavior: 'smooth', block: 'center' });
      });
    } else {
      e.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
  };

  public handleToggleSubClientMenuList = () => {
    const show = !this.state.showSubClientMenuList;
    const errors = [...this.state.formErrors];
    this.setState({
      showSubClientMenuList: show,
      parentClientName: '',
      parentClients: 0,
      formErrors: errors.filter((item) => !item.startsWith("In the client's organization system")),
      formFields: {
        ...this.state.formFields,
        parentClientId: show ? this.state.parentClientId : null,
        billToParent: show ? this.state.formFields.billToParent : false,
        billingDetails: show
          ? this.state.formFields.billingDetails
          : this.preFillFields(this.state.formFields),
      },
    });
  };

  private handleClearKeyword = () => {
    this.handleSelectClient(0, '');
  };

  private handleChangeInactiveClient = () => {
    this.setState({
      formFields: {
        ...this.state.formFields,
        active: !this.state.formFields.active,
      },
    });
  };

  private handleSearch: MainInfoProps['handleSearch'] = async (text) => {
    const { accountId, client } = this.props;

    const res = await searchClients({
      text,
      accountId,
      excludeId: !this.props.addSubClient && client ? client.id : undefined,
    });

    if (res.error) {
      return [];
    }
    return res
      .filter((item: any) =>
        client
          ? // if we have a `client` to exclude, drop any item whose parent.id === client.id
            !(item.parent && item.parent.id === client.id)
          : true
      )
      .map((r: any) => ({
        id: r.id,
        displayName: r.displayName,
        parentName: r.parent && r.parent.displayName, // undefined if no parent
      }));
  };

  private getMaxDepthIterative = (rootClient: ClientModule.Client): number => {
    let maxDepth = 0;
    const stack: { client: ClientModule.Client; depth: number }[] = [
      { client: rootClient, depth: 1 },
    ];
    if (rootClient) {
      while (stack.length > 0) {
        const { client, depth } = stack.pop()!;
        maxDepth = Math.max(maxDepth, depth);
        for (const subClient of client.subClients) {
          stack.push({ client: subClient, depth: depth + 1 });
        }
      }
    }
    return maxDepth;
  };

  private handleSelectClient = async (id: number, name: string) => {
    const updatedForm = {
      ...this.state.formFields,
      billToParent: !!id,
    };
    updatedForm.parentClientId = id;
    const { accountId, client } = this.props;
    let res;
    let res2;

    if (updatedForm.billToParent) {
      res = await getClientApi({ clientId: id, accountId });
      if (client) res2 = await getClientApi({ clientId: client.id, accountId });
      if (!res.error) {
        const parent = res;
        updatedForm.billingDetails = normalizeBillingFieldValues(
          parent.billToParent ? parent.billingDetails : parent.billingDetailsDirectly,
          parent.company
        );
      }
    }
    if (updatedForm.billingDetails) {
      updatedForm.billingDetails['additionalPriceAdjustment'] =
        updatedForm?.billingDetails?.additionalPriceAdjustment || 'none';
      updatedForm.billingDetails['additionalPriceAdjustmentValue'] =
        updatedForm?.billingDetails?.additionalPriceAdjustmentValue || '';
    }
    if (updatedForm.billingDetailsDirectly) {
      updatedForm.billingDetailsDirectly['additionalPriceAdjustment'] =
        updatedForm?.billingDetailsDirectly?.additionalPriceAdjustment || 'none';
      updatedForm.billingDetailsDirectly['additionalPriceAdjustmentValue'] =
        updatedForm?.billingDetailsDirectly?.additionalPriceAdjustmentValue || '';
    }
    this.setState({
      parentClientName: name,
      parentClientId: id,
      formFields: updatedForm,
      isParentChanged: id !== this.state.parentClientId,
      parentClients: id
        ? !this.props.client
          ? res
            ? res.parentClients.length + 1
            : []
          : this.getMaxDepthIterative(res2) + res.parentClients.length
        : 0,
    });
  };

  private handleClose = (type: string) => {
    const { client, addSubClient } = this.props;
    this.handleAddClientError(false, '');

    if (this.state.additionalFormOpen) {
      this.setState({ isOpen: true });
      return;
    }

    if (this.props.resetOnClose) {
      let formFields: ClientFields;
      if (client) {
        formFields = {
          ...client,
          billingDetails: {
            ...client.billingDetails,
          },
          additionalContactDetails: [...client.additionalContactDetails],
        };
      } else {
        formFields = defaultFieldValues();
      }

      this.setState({
        formFields,
        parentClientName: client && client.parent ? client.parent.displayName : '',
        parentClientId: client && client.parent ? client.parent.id : 0,
        formErrors: [],
        showSubClientMenuList: addSubClient ? true : client && client.parent ? true : false,
        isCustomDisplayName: false,
        tabIndex: this.props.tabIndex ? this.props.tabIndex : 0,
        isParentChanged: false,
        emailValidationErrors: {},
      });
    }
    if (type === 'cancel' && !this.state.billingType && this.props.updateStateByName) {
      this.props.updateStateByName(
        this.state.formFields.billToParent
          ? 'client.billingDetails.billingType'
          : 'client.billingDetailsDirectly.billingType',
        this.state.billingType
      );
    }
    this.setState({ parentClients: 0 });
    this.props.onModalClose();
  };

  private handleBillToParent = async (value: string, updatedForm: ClientFields) => {
    const val = parseInt(value, 10);
    updatedForm.billToParent = val === 1;

    const extractedParent = extractParent(this.props.client);

    if (val === 1) {
      if (this.props.addSubClient && !this.state.isParentChanged) {
        if (this.props.client) {
          if (!this.props.client.billToParent) {
            updatedForm.billingDetails = normalizeBillingFieldValues(
              this.props.client.billingDetailsDirectly,
              this.props.client.company
            );
            updatedForm.billingDetails['additionalPriceAdjustment'] =
              this.props.client.billingDetailsDirectly?.additionalPriceAdjustment || 'none';
            updatedForm.billingDetails['additionalPriceAdjustmentValue'] =
              this.props.client.billingDetailsDirectly?.additionalPriceAdjustmentValue || '';
          } else {
            updatedForm.billingDetails = {
              additionalPriceAdjustment:
                extractedParent?.billingInfoDirectly?.additionalPriceAdjustment ||
                this.props.client.billingDetails?.additionalPriceAdjustment ||
                'none',
              additionalPriceAdjustmentValue:
                extractedParent?.billingInfoDirectly?.additionalPriceAdjustmentValue ||
                this.props.client.billingDetails?.additionalPriceAdjustmentValue ||
                '',
              firstName:
                extractedParent?.billingInfoDirectly?.firstName ||
                this.props.client.billingDetails.firstName,
              lastName:
                extractedParent?.billingInfoDirectly?.lastName ||
                this.props.client.billingDetails.lastName,
              company:
                extractedParent?.billingInfoDirectly?.company ||
                extractedParent?.billingInfoDirectly?.companyName ||
                this.props.client.billingDetails.company ||
                this.props.client.company,
              email:
                extractedParent?.billingInfoDirectly?.email ||
                this.props.client.billingDetails.email,
              cellPhone:
                extractedParent?.billingInfoDirectly?.cellPhone ||
                this.props.client.billingDetails.cellPhone,
              homePhone:
                extractedParent?.billingInfoDirectly?.homePhone ||
                this.props.client.billingDetails.homePhone,
              officePhone:
                extractedParent?.billingInfoDirectly?.officePhone ||
                this.props.client.billingDetails.officePhone,
              fax:
                extractedParent?.billingInfoDirectly?.fax || this.props.client.billingDetails.fax,
              website:
                extractedParent?.billingInfoDirectly?.website ||
                this.props.client.billingDetails.website,
              streetAddress:
                extractedParent?.billingInfoDirectly?.streetAddress ||
                this.props.client.billingDetails.streetAddress,
              unitSuite:
                extractedParent?.billingInfoDirectly?.unitSuite ||
                this.props.client.billingDetails.unitSuite,
              cityTown:
                extractedParent?.billingInfoDirectly?.cityTown ||
                this.props.client.billingDetails.cityTown,
              stateProvince:
                extractedParent?.billingInfoDirectly?.stateProvince ||
                this.props.client.billingDetails.stateProvince,
              zipCode:
                extractedParent?.billingInfoDirectly?.zipCode ||
                this.props.client.billingDetails.zipCode,
              country:
                extractedParent?.billingInfoDirectly?.country ||
                this.props.client.billingDetails.country,
              billingType:
                extractedParent?.billingInfoDirectly?.billingType ||
                this.props.client.billingDetails.billingType,
            };
          }
        }
      } else if (this.state.formFields.parentClientId && this.state.isParentChanged) {
        const res = await getClientApi({
          clientId: this.state.formFields.parentClientId,
          accountId: this.props.accountId,
        });

        if (!res.error) {
          const parent = res;
          if (this.props.addSubClient && this.state.isParentChanged) {
            updatedForm.billingDetails = normalizeBillingFieldValues(
              parent.billToParent ? parent.billingDetails : parent.billingDetailsDirectly,
              parent.company
            );
            // additional price adjustment
            updatedForm.billingDetails['additionalPriceAdjustment'] = parent.billToParent
              ? parent.billingDetails?.additionalPriceAdjustment || 'none'
              : parent.billingDetailsDirectly?.additionalPriceAdjustment || 'none';
            // additional price adjustment value
            updatedForm.billingDetails['additionalPriceAdjustmentValue'] = parent.billToParent
              ? parent.billingDetails?.additionalPriceAdjustmentValue || ''
              : parent.billingDetailsDirectly?.additionalPriceAdjustmentValue || '';
          } else if (
            (this.props.client && !this.props.client.parentClientId) ||
            !this.props.client
          ) {
            updatedForm.billingDetails = normalizeBillingFieldValues(
              parent.billToParent ? parent.billingDetails : parent.billingDetailsDirectly,
              parent.company
            );
            // additional price adjustment
            updatedForm.billingDetails['additionalPriceAdjustment'] = parent.billToParent
              ? parent.billingDetails?.additionalPriceAdjustment || 'none'
              : parent.billingDetailsDirectly?.additionalPriceAdjustment || 'none';
            // additional price adjustment value
            updatedForm.billingDetails['additionalPriceAdjustmentValue'] = parent.billToParent
              ? parent.billingDetails?.additionalPriceAdjustmentValue || ''
              : parent.billingDetailsDirectly?.additionalPriceAdjustmentValue || '';
          } else if (this.props.client) {
            updatedForm.billingDetails = normalizeBillingFieldValues(
              parent.billToParent ? parent.billingDetails : parent.billingDetailsDirectly,
              parent.company
            );
            // additional price adjustment
            updatedForm.billingDetails['additionalPriceAdjustment'] = parent.billToParent
              ? parent.billingDetails?.additionalPriceAdjustment || 'none'
              : parent.billingDetailsDirectly?.additionalPriceAdjustment || 'none';
            // additional price adjustment value
            updatedForm.billingDetails['additionalPriceAdjustmentValue'] = parent.billToParent
              ? parent.billingDetails?.additionalPriceAdjustmentValue || ''
              : parent.billingDetailsDirectly?.additionalPriceAdjustmentValue || '';
          }
          updatedForm.billingType = parent.billingType;
          if (parent.billingType) {
            this.handleFieldFromSelect(parent.billingType, 'client.billingType');
          }
        }
      } else if (
        this.state.formFields.parentClientId &&
        !this.state.isParentChanged &&
        this.props.client
      ) {
        updatedForm.billingDetails = {
          additionalPriceAdjustment:
            extractedParent?.billingInfoDirectly?.additionalPriceAdjustment ||
            this.props.client.billingDetails?.additionalPriceAdjustment ||
            'none',
          additionalPriceAdjustmentValue:
            extractedParent?.billingInfoDirectly?.additionalPriceAdjustmentValue ||
            this.props.client.billingDetails?.additionalPriceAdjustmentValue ||
            '',
          firstName:
            extractedParent?.billingInfoDirectly?.firstName ||
            this.props.client.billingDetails.firstName,
          lastName:
            extractedParent?.billingInfoDirectly?.lastName ||
            this.props.client.billingDetails.lastName,
          company:
            extractedParent?.billingInfoDirectly?.company ||
            extractedParent?.billingInfoDirectly?.companyName ||
            this.props.client.billingDetails.company ||
            this.props.client.company,
          email:
            extractedParent?.billingInfoDirectly?.email || this.props.client.billingDetails.email,
          cellPhone:
            extractedParent?.billingInfoDirectly?.cellPhone ||
            this.props.client.billingDetails.cellPhone,
          homePhone:
            extractedParent?.billingInfoDirectly?.homePhone ||
            this.props.client.billingDetails.homePhone,
          officePhone:
            extractedParent?.billingInfoDirectly?.officePhone ||
            this.props.client.billingDetails.officePhone,
          fax: extractedParent?.billingInfoDirectly?.fax || this.props.client.billingDetails.fax,
          website:
            extractedParent?.billingInfoDirectly?.website ||
            this.props.client.billingDetails.website,
          streetAddress:
            extractedParent?.billingInfoDirectly?.streetAddress ||
            this.props.client.billingDetails.streetAddress,
          unitSuite:
            extractedParent?.billingInfoDirectly?.unitSuite ||
            this.props.client.billingDetails.unitSuite,
          cityTown:
            extractedParent?.billingInfoDirectly?.cityTown ||
            this.props.client.billingDetails.cityTown,
          stateProvince:
            extractedParent?.billingInfoDirectly?.stateProvince ||
            this.props.client.billingDetails.stateProvince,
          zipCode:
            extractedParent?.billingInfoDirectly?.zipCode ||
            this.props.client.billingDetails.zipCode,
          country:
            extractedParent?.billingInfoDirectly?.country ||
            this.props.client.billingDetails.country,
          billingType:
            extractedParent?.billingInfoDirectly?.billingType ||
            this.props.client.billingDetails.billingType,
        };
      }
    } else {
      if (this.props.addSubClient) {
        updatedForm.billingDetailsDirectly = {
          additionalPriceAdjustment:
            this.state.formFields.billingDetailsDirectly?.additionalPriceAdjustment || 'none',
          additionalPriceAdjustmentValue:
            this.state.formFields.billingDetailsDirectly?.additionalPriceAdjustmentValue || '',
          firstName: this.state.formFields.firstName,
          lastName: this.state.formFields.lastName,
          company: this.state.formFields.company,
          email: this.state.formFields.email,
          cellPhone: this.state.formFields.cellPhone,
          homePhone: this.state.formFields.homePhone,
          officePhone: this.state.formFields.officePhone,
          fax: this.state.formFields.fax,
          website: this.state.formFields.website,
          streetAddress: this.state.formFields.streetAddress,
          unitSuite: this.state.formFields.unitSuite,
          cityTown: this.state.formFields.cityTown,
          stateProvince: this.state.formFields.stateProvince,
          zipCode: this.state.formFields.zipCode,
          country: this.state.formFields.country,
          billingType: this.props.addSubClient
            ? ''
            : (this.state.formFields.billingDetailsDirectly &&
                this.state.formFields.billingDetailsDirectly.billingType) ||
              '',
        };
      } else if (this.props.client) {
        updatedForm.billingDetailsDirectly = {
          additionalPriceAdjustment:
            this.state.formFields?.billingDetailsDirectly?.additionalPriceAdjustment || 'none',
          additionalPriceAdjustmentValue:
            this.state.formFields?.billingDetailsDirectly?.additionalPriceAdjustmentValue || '',
          firstName: this.state.formFields ? this.state.formFields.firstName : '',
          lastName: this.state.formFields ? this.state.formFields.lastName : '',
          company: this.state.formFields ? this.state.formFields.company : '',
          email: this.state.formFields ? this.state.formFields.email : '',
          cellPhone: this.state.formFields ? this.state.formFields.cellPhone : '',
          homePhone: this.state.formFields ? this.state.formFields.homePhone : '',
          officePhone: this.state.formFields ? this.state.formFields.officePhone : '',
          fax: this.state.formFields ? this.state.formFields.fax : '',
          website: this.state.formFields ? this.state.formFields.website : '',
          streetAddress: this.state.formFields ? this.state.formFields.streetAddress : '',
          unitSuite: this.state.formFields ? this.state.formFields.unitSuite : '',
          cityTown: this.state.formFields ? this.state.formFields.cityTown : '',
          stateProvince: this.state.formFields ? this.state.formFields.stateProvince : '',
          zipCode: this.state.formFields ? this.state.formFields.zipCode : '',
          country: this.state.formFields ? this.state.formFields.country : '',
        };
        updatedForm.billingDetailsDirectly.billingType = this.props.client.billingDetailsDirectly
          ? this.props.client.billingDetailsDirectly.billingType
          : '';
      } else {
        updatedForm.billingDetailsDirectly = {
          additionalPriceAdjustment:
            this.state.formFields.billingDetailsDirectly?.additionalPriceAdjustment || 'none',
          additionalPriceAdjustmentValue:
            this.state.formFields.billingDetailsDirectly?.additionalPriceAdjustmentValue || '',
          firstName: this.state.formFields.firstName,
          lastName: this.state.formFields.lastName,
          company: this.state.formFields.company,
          email: this.state.formFields.email,
          cellPhone: this.state.formFields.cellPhone,
          homePhone: this.state.formFields.homePhone,
          officePhone: this.state.formFields.officePhone,
          fax: this.state.formFields.fax,
          website: this.state.formFields.website,
          streetAddress: this.state.formFields.streetAddress,
          unitSuite: this.state.formFields.unitSuite,
          cityTown: this.state.formFields.cityTown,
          stateProvince: this.state.formFields.stateProvince,
          zipCode: this.state.formFields.zipCode,
          country: this.state.formFields.country,
        };
      }
    }
    return updatedForm;
  };

  private handleDisplayName = (key: string, updatedForm: ClientFields) => {
    if (['firstName', 'lastName', 'company'].includes(key) && !this.state.isCustomDisplayName) {
      const { firstName, lastName, company } = updatedForm;
      let displayNames = '';
      if (this.props.addSubClient) {
        if (firstName && lastName) {
          displayNames = `${lastName}, ${firstName}`;
        } else {
          this.handleAddClientError(false, '');
          displayNames = lastName || firstName || company || '';
        }
        updatedForm.displayName = displayNames;
      } else if (!this.state.canChange) {
        if (firstName && lastName) {
          displayNames = `${lastName}, ${firstName}`;
        } else {
          this.handleAddClientError(false, '');
          displayNames = lastName || firstName || company || '';
        }
        updatedForm.displayName = displayNames;
      }
    }

    return updatedForm;
  };

  @Bind()
  private async handleInitialBillingInfo(value: string, formFields: any): Promise<void> {
    let updatedForm = {
      ...formFields,
    };

    updatedForm = await this.handleBillToParent(value, updatedForm);
    this.setState({ formFields: updatedForm });
  }

  @Bind()
  private handleInitialBillingInfoWrapper(value: string, formFields: any): void {
    this.handleInitialBillingInfo(value, formFields).catch((error: Error) => {
      throw Error(error.message);
    });
  }

  @Bind()
  private async handleFieldChange(
    e: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>,
    val?: string
  ): Promise<void> {
    let updatedForm = {
      ...this.state.formFields,
    };
    const namePath = e.currentTarget.name;
    let key = namePath;
    let value = e.currentTarget.value;

    if (namePath.endsWith('Phone')) {
      value = formatPhoneNumber(value);
    }

    // let updatedEmailErrors = { ...this.state.emailValidationErrors };
    // if (namePath.toLowerCase().endsWith('email')) {
    //     delete updatedEmailErrors[namePath];
    // }

    if ((key.includes('firstName') || key.includes('lastName')) && val !== 'billing') {
      if (this.props.addSubClient) {
        const fullname =
          key === 'firstName'
            ? value + ', ' + this.state.formFields.lastName
            : this.state.formFields.firstName + ', ' + value;
        updatedForm = {
          ...this.state.formFields,
          displayName: fullname,
        };

        this.handleAddClientError(false, '');
      } else if (
        (this.state.formFields.firstName || this.state.formFields.lastName) &&
        !this.state.canChange
      ) {
        const fullName =
          key === 'firstName'
            ? value + ', ' + this.state.formFields.lastName
            : this.state.formFields.firstName + ', ' + value;
        updatedForm = {
          ...this.state.formFields,
          displayName: fullName,
        };

        this.handleAddClientError(false, '');
      }
    }

    if (key.includes('additionalContactDetails.')) {
      key = key.split('.').pop()!;
      updatedForm.additionalContactDetails[key] = value;
    } else if (key.includes('billingDetails.')) {
      key = key.split('.').pop()!;
      this.state.formFields.billToParent
        ? (updatedForm.billingDetails![key] = value)
        : (updatedForm.billingDetailsDirectly![key] = value);
      if (this.state.formFields.billToParent === false) {
        this.setState((prevState) => ({
          ...prevState,
          clientBillingDetails: {
            ...prevState.clientBillingDetails,
            [key]: value,
          },
        }));
      }
    } else {
      if (key === 'billToParent') {
        updatedForm = await this.handleBillToParent(value, updatedForm);
      } else {
        if (!this.state.formFields.billToParent) {
          if (
            updatedForm.billingDetailsDirectly &&
            Object.entries(updatedForm.billingDetailsDirectly).length === 0
          ) {
            updatedForm.billingDetailsDirectly = defaultBillingFieldValues();
            updatedForm.billingDetailsDirectly[key] = value;
          } else if (
            updatedForm.billingDetailsDirectly &&
            ((updatedForm.billingDetailsDirectly.hasOwnProperty(key) &&
              !this.isCustomBillingInfo(updatedForm.billingDetailsDirectly, key)) ||
              !updatedForm.billingDetailsDirectly.hasOwnProperty(key))
          ) {
            updatedForm.billingDetailsDirectly[key] = value;
          }
        }
        updatedForm[key] = value;
        updatedForm = this.handleDisplayName(key, updatedForm);
      }
    }
    // updatedEmailErrors = this.syncPrimaryEmailErrors(updatedForm, updatedEmailErrors);
    this.setState({ formFields: updatedForm, emailValidationErrors: {} });
  }

  private getBillingEmailValue(form: ClientFields): string {
    if (form.billToParent) {
      return (form.billingDetails && form.billingDetails.email) || '';
    }
    return (form.billingDetailsDirectly && form.billingDetailsDirectly.email) || '';
  }

  private syncPrimaryEmailErrors(
    form: ClientFields,
    currentErrors: Record<string, string>
  ): Record<string, string> {
    const nextErrors = { ...currentErrors };
    delete nextErrors.email;
    delete nextErrors['billingDetails.email'];
    delete nextErrors['billingDetailsDirectly.email'];

    const primaryEmailMessage = getEmailValidationMessage(form.email || '');
    if (primaryEmailMessage) {
      nextErrors.email = primaryEmailMessage;
    }

    const billingEmailMessage = getEmailValidationMessage(this.getBillingEmailValue(form));
    if (billingEmailMessage) {
      nextErrors['billingDetails.email'] = billingEmailMessage;
    }

    return nextErrors;
  }

  private preFillFields(
    billingDetails: ClientModule.ClientAddressDetails
  ): ClientModule.ClientAddressDetails {
    const updatedForm = {
      ...this.state.formFields,
    };
    billingDetails = defaultBillingFieldValues();
    for (const key in updatedForm) {
      if (billingDetails.hasOwnProperty(key)) {
        billingDetails[key] = updatedForm[key];
      }
    }
    return billingDetails;
  }

  private isCustomBillingInfo(
    billingDetails: ClientModule.ClientAddressDetails,
    key?: string
  ): boolean {
    const updatedForm = {
      ...this.state.formFields,
    };
    for (const k in updatedForm) {
      if (key) {
        if (billingDetails.hasOwnProperty(key) && key === k) {
          if (billingDetails[key] !== updatedForm[key] && billingDetails[key]) {
            return true;
          }
        }
      } else {
        if (billingDetails.hasOwnProperty(k)) {
          if (billingDetails[k] !== updatedForm[k] && billingDetails[k]) {
            return true;
          }
        }
      }
    }
    return false;
  }

  private handleKeyPressForm(e: KeyboardEvent<HTMLElement>) {
    if (e.which === 13 && (e.target as HTMLTextAreaElement).name !== 'notes') {
      e.preventDefault();
      return;
    }
  }

  private async handleClientSubmit() {
    // Reset error on submit
    this.handleAddClientError(false, '');
    const { client, onClientSaved } = this.props;
    if (client) {
      const res = await editClient({
        client: { ...this.state.formFields },
      });

      if (res.error) {
        // Set error if it occurs
        const error_message = res.message || res.data.message || '';
        this.handleAddClientError(true, error_message);
        this.setState((prev) => ({ ...prev, tabIndex: 0 }));

        if (res.name === 'ValidationError') {
          const errors = (res as Error as ValidationError).errors;
          if (errors.displayName) {
            errors.displayName = errors.displayName.replace('DisplayName', 'Display Name');
          }
          throw FormValidationError.fromErrorDictionary(errors);
        } else {
          throw new Error(res.message);
        }
      } else {
        // Reset error if success
        this.handleAddClientError(false, '');

        this.setState({
          isParentChanged: false,
        });
        try {
          const refreshedClient = await getClientApi({
            clientId: this.state.formFields.id,
            accountId: this.props.accountId,
          });

          if (!refreshedClient?.error && refreshedClient?.id) {
            onClientSaved(refreshedClient);
            return;
          }
        } catch (refreshError) {
          console.error('Failed to refresh client after save:', refreshError);
        }

        onClientSaved({
          ...this.state.formFields,
          subClients: client.subClients,
          subClientsIds: client.subClientsIds,
        });
      }
    }
  }

  public handleAddClientError = (error: boolean, message: string) => {
    this.setState((prev: any) => {
      return {
        ...prev,
        addClientError: {
          error: error,
          message: message,
        },
      };
    });
  };

  @Bind()
  private async handleSubmitForm(e: FormEvent<HTMLFormElement>): Promise<void> {
    e.preventDefault();

    // Reset error on submit
    this.handleAddClientError(false, '');

    if (this.state.formFields.displayName && this.state.formFields.displayName.includes(':')) {
      this.handleAddClientError(true, 'Display name cannot contain ":"');
      return;
    }

    const syncedEmailErrors = this.syncPrimaryEmailErrors(
      this.state.formFields,
      this.state.emailValidationErrors
    );

    const emailErrorsChanged =
      Object.keys(this.state.emailValidationErrors).length !==
        Object.keys(syncedEmailErrors).length ||
      Object.keys(syncedEmailErrors).some(
        (key) => this.state.emailValidationErrors[key] !== syncedEmailErrors[key]
      );

    if (emailErrorsChanged) {
      this.setState({ emailValidationErrors: syncedEmailErrors });
    }

    const hasEmailValidationIssue = Object.keys(syncedEmailErrors).length > 0;

    if (hasEmailValidationIssue) {
      if (syncedEmailErrors && syncedEmailErrors.email) {
        this.setState({ tabIndex: 0 });
      } else if (syncedEmailErrors && syncedEmailErrors['billingDetails.email']) {
        this.setState({ tabIndex: 1 });
      }
      return;
    }

    const { accountId, client, onClientSaved, addSubClient } = this.props;
    if (this.state.parentClients <= 3) {
      if (!client || addSubClient) {
        const res = await addClient({
          client: { ...this.state.formFields },
          accountId,
        });

        if (res.error) {
          // Set error if it occurs
          const error_message = res.message || res.data.message || '';
          this.handleAddClientError(true, error_message);
          this.setState((prev) => ({ ...prev, tabIndex: 0 }));

          if (res.name === 'ValidationError') {
            const errors = (res as Error as ValidationError).errors;
            if (errors.displayName) {
              errors.displayName = errors.displayName.replace('DisplayName', 'Display Name');
            }
            throw FormValidationError.fromErrorDictionary(errors);
          } else {
            throw new Error(res.message);
          }
        }

        // Reset error if success
        this.handleAddClientError(false, '');

        if (res && res.id) {
          const payload = {
            clientId: res.id,
            accountId: accountId,
          };
          await addProject(payload);
        }

        onClientSaved(res);
        this.setState({
          isParentChanged: false,
          formFields: {
            ...this.state.formFields,
            canChange: this.state.formFields.customDisplayName ? true : false,
          },
        });
        if (this.props.getRooms) {
          this.props.getRooms(res.id);
        }
      } else {
        await this.handleClientSubmit();
      }
      if (this.props.onUpdateModalKey) {
        this.props.onUpdateModalKey();
      }
      if (this.props && this.props.getClient) {
        await this.props.getClient();
      }
      this.handleClose('submit');
    } else {
      const errors = [...this.state.formErrors];
      const message = "In the client's organization system, a maximum of four levels are possible.";
      if (!errors.includes(message)) {
        errors.push(message);
      }
      this.setState({ formErrors: errors });
    }
  }

  private openAvatarModal = () => {
    this.setState({
      imageModalOpen: true,
    });
  };

  private closeAvatarModal = () => {
    this.setState({
      imageModalOpen: false,
    });
  };

  private saveAvatarImage = async (file: File) => {
    if (file.size > 2 * 1024 * 1024) {
      try {
        file = await this.compressImage(file);
      } catch (error) {
        throw new Error('An error occurred while compressing the image.');
      }
    }

    const { accountId } = this.props;
    const formData = new FormData();
    formData.append('file', file);
    formData.append('accountId', accountId.toString());
    formData.append('fileStoreUrl', Config.fileStoreUrl);
    const res = await uploadImage(formData);
    if (res.error) {
      throw new Error(res.message);
    }
    this.setState({
      formFields: {
        ...this.state.formFields,
        avatarId: res.url,
      },
      imageModalOpen: false,
    });
  };

  private compressImage = (file: File): Promise<File> => {
    return new Promise((resolve) => {
      const reader = new FileReader();

      reader.onload = (event) => {
        const target = event.target as FileReader;
        if (!target || !target.result) return;
        const img = new Image();
        img.src = target.result as string;
        img.onload = () => {
          const maxWidth = 1024;
          const maxHeight = 1024;
          let width = img.width;
          let height = img.height;

          if (width > maxWidth || height > maxHeight) {
            const aspectRatio = width / height;
            if (width > height) {
              width = maxWidth;
              height = width / aspectRatio;
            } else {
              height = maxHeight;
              width = height * aspectRatio;
            }
          }

          const canvas = document.createElement('canvas');
          const ctx = canvas.getContext('2d');
          if (!ctx) {
            resolve(file);
            return;
          }

          canvas.width = width;
          canvas.height = height;

          ctx.drawImage(img, 0, 0, width, height);

          canvas.toBlob(
            (blob) => {
              if (!blob) {
                resolve(file);
                return;
              }
              const compressedFile = new File([blob], file.name, {
                type: file.type,
                lastModified: file.lastModified,
              });
              resolve(compressedFile);
            },
            'image/jpeg',
            0.7
          );
        };
      };

      reader.readAsDataURL(file);
    });
  };

  private deleteAvatarImage = () => {
    this.setState({
      formFields: {
        ...this.state.formFields,
        avatarId: undefined,
      },
    });
  };

  public handleAdditionalPriceAdjustmentValueBlur = (e: ChangeEvent<HTMLInputElement>) => {
    let { name, value } = e.target;

    if (value) {
      if (value.endsWith('.')) {
        value += '00';
      } else if (value?.split('.')?.[1]?.length === 1) {
        value += '0';
      } else if (!value.includes('.')) {
        value += '.00';
      }

      this.setState((prev) => {
        const temp_obj = prev.formFields.billToParent
          ? prev.formFields.billingDetails
          : prev.formFields.billingDetailsDirectly;
        const temp_obj_key = prev.formFields.billToParent
          ? 'billingDetails'
          : 'billingDetailsDirectly';
        return {
          ...prev,
          formFields: {
            ...prev.formFields,
            [temp_obj_key]: {
              ...temp_obj,
              [name]: value,
            },
          },
        };
      });
    }
  };

  public handleAdditionalPriceAdjustmentValue = (e: ChangeEvent<HTMLInputElement>) => {
    let { name, value } = e.target;
    const decimalNumbersRegex = /^$|^(0|[1-9]\d*)(\.\d{0,2})?$/;

    if (value && !decimalNumbersRegex.test(value)) return;

    this.setState((prev) => {
      const temp_obj = prev.formFields.billToParent
        ? prev.formFields.billingDetails
        : prev.formFields.billingDetailsDirectly;
      const temp_obj_key = prev.formFields.billToParent
        ? 'billingDetails'
        : 'billingDetailsDirectly';
      return {
        ...prev,
        formFields: {
          ...prev.formFields,
          [temp_obj_key]: {
            ...temp_obj,
            [name]: value,
          },
        },
      };
    });
  };

  public handleAdditionalPriceAdjustment = (val: string, name: string): void => {
    this.setState((prev) => {
      const temp_obj = prev.formFields.billToParent
        ? prev.formFields.billingDetails
        : prev.formFields.billingDetailsDirectly;
      const temp_obj_key = prev.formFields.billToParent
        ? 'billingDetails'
        : 'billingDetailsDirectly';
      return {
        ...prev,
        formFields: {
          ...prev.formFields,
          [temp_obj_key]: {
            ...temp_obj,
            [name]: val,
            additionalPriceAdjustmentValue:
              val === 'none' ? '' : temp_obj?.additionalPriceAdjustmentValue || '',
          },
        },
      };
    });
  };

  private handleFieldFromSelect = (value: string, name: string): void => {
    this.setState({
      formFields: {
        ...this.state.formFields,
        [name]: value,
      },
    });

    if (name !== 'billingType') {
      this.setState({
        formFields: {
          ...this.state.formFields,
          [name]: value,
        },
      });
    } else {
      if (this.state.formFields.billToParent) {
        this.setState({
          formFields: {
            ...this.state.formFields,
            billingDetails: {
              ...this.state.formFields.billingDetails,
              [name]: value,
            },
          },
        });
      } else {
        this.setState({
          formFields: {
            ...this.state.formFields,
            billingDetailsDirectly: {
              ...this.state.formFields.billingDetailsDirectly,
              [name]: value,
            },
          },
        });
      }
      if (this.props.clearHighlightSection && this.props.highlightedSection === name)
        this.props.clearHighlightSection(name);
    }

    if (name === 'billingType') {
      this.props.updateStateByName &&
        this.props.updateStateByName(
          this.state.formFields.billToParent
            ? 'client.billingDetails.billingType'
            : 'client.billingDetailsDirectly.billingType',
          value
        )!;
    }
  };

  private handleFieldState = (value: string, name: string) => {
    if (name === 'stateProvince' || name === 'billingDetails.stateProvince') {
      // return;
    }
    const updatedForm = {
      ...this.state.formFields,
    };

    let key = name;

    if (key.includes('billingDetails.')) {
      key = key.split('.').pop()!;
      if (updatedForm.billToParent) {
        updatedForm.billingDetails![key] = value;
      } else {
        updatedForm.billingDetailsDirectly![key] = value;
      }
    } else {
      if (updatedForm.billToParent) {
        updatedForm.billingDetails![key] = value;
      } else {
        updatedForm.billingDetailsDirectly![key] = value;
      }
      updatedForm[key] = value;
    }

    this.setState({
      formFields: updatedForm,
    });
  };

  private handleChangeDisplayName = (value: string) => {
    const { firstName, lastName } = this.state.formFields;
    const isCustomDisplayName =
      value !== '' &&
      (value !== `${lastName} ${firstName}` || value !== `${firstName} ${lastName}`);
    const newValue = value.includes(',') ? value.split(',').join('') : value;
    this.setState({
      formFields: {
        ...this.state.formFields,
        displayName: value,
        customDisplayName:
          newValue !== `${lastName} ${firstName}` && newValue !== `${firstName} ${lastName}`
            ? true
            : false,
      },
      isCustomDisplayName,
    });

    // Reset the error
    this.handleAddClientError(false, '');
  };

  private changeAdditionalContacts: AdditionalContatctsProps['onAdditionalContactsChanged'] = (
    contacts
  ) => {
    this.setState({
      formFields: {
        ...this.state.formFields,
        additionalContactDetails: contacts,
      },
      additionalFormOpen: false,
    });
  };

  private deleteAdditionalContact = (index: number): void => {
    const updateAdditionalContacts = this.state.formFields.additionalContactDetails.filter(
      (_, i) => i !== index
    );

    this.setState({
      formFields: {
        ...this.state.formFields,
        additionalContactDetails: updateAdditionalContacts,
      },
    });
  };

  private setAdditionalFormStatus = (status: 'open' | 'closed'): void => {
    this.setState({
      additionalFormOpen: status === 'open',
    });
  };
}

function mapStateToProps(state: RootState, ownProps: ClientModalOwnProps): ClientModalProps {
  return {
    ...ownProps,
    accountId: parseFloat(localStorage.getItem('accountId') || '0'),
  };
}

export default connect(mapStateToProps)(ClientModal);
